import React from 'react';
import '../styles/modal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'warning',
  isLoading = false
}) => {
  if (!isOpen) return null;

  const getTypeColors = () => {
    switch (type) {
      case 'danger':
        return {
          iconColor: '#EF4444',
          confirmBg: '#e54a4a',
          confirmHover: '#d63f3f'
        };
      case 'warning':
        return {
          iconColor: '#F59E0B',
          confirmBg: '#F59E0B',
          confirmHover: '#D97706'
        };
      case 'info':
      default:
        return {
          iconColor: '#3B82F6',
          confirmBg: '#3B82F6',
          confirmHover: '#2563EB'
        };
    }
  };

  const colors = getTypeColors();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: `${colors.iconColor}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke={colors.iconColor}
                strokeWidth="2"
              >
                <path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/>
              </svg>
            </div>
            <h2 style={{
              margin: 0,
              fontSize: '17px',
              fontWeight: '600',
              color: 'rgba(89, 90, 108, 1)'
            }}>
              {title}
            </h2>
          </div>
          <span
            className="close-btn"
            onClick={onClose}
          >
            ×
          </span>
        </div>

        <div style={{
          padding: '0',
          color: '#4B5563',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          {message}
        </div>

        <div className="modal-footer">
          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            className="remove-btn"
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              backgroundColor: colors.confirmBg,
              opacity: isLoading ? 0.7 : 1,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.currentTarget.style.backgroundColor = colors.confirmHover;
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.currentTarget.style.backgroundColor = colors.confirmBg;
              }
            }}
          >
            {isLoading && (
              <div
                style={{
                  width: '14px',
                  height: '14px',
                  border: '2px solid #ffffff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}
              />
            )}
            {isLoading ? 'Removing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;